<script setup>
import {defineEmits, onUnmounted} from 'vue'
import {useAuthenticationStore, useDefaultStore} from '@/stores'
import {storeToRefs} from 'pinia'
import {formatSum} from '@shared/utils/helpers'

const {closeBalanceAlertModalAndFetch, openInvoiceModal} = useDefaultStore()
const {user, userAvailableBalance, userRemainingBalanceDays, userBalanceStatus} = storeToRefs(useAuthenticationStore())
const emit = defineEmits(['hidden'])

onUnmounted(() => emit('hidden'))
</script>

<template>
  <div class="alert-modal">
    <div class="alert-inner">
      <button @click="closeBalanceAlertModalAndFetch" class="btn-close"></button>

      <div
        v-if="user?.company?.balance_info"
        class="d-flex-center align-items-center justify-content-center flex-column"
      >
        <div class="pulse">
          <img
            v-if="userBalanceStatus === 'low_balance'"
            src="~@shared-images/icons/user-balance/balance-warning.svg"
            alt="warning"
          />
          <img
            v-else-if="userBalanceStatus === 'critical_balance' && userRemainingBalanceDays > 0"
            src="~@shared-images/icons/user-balance/balance-danger.svg"
            alt="danger"
          />
          <img v-else src="~@shared-images/icons/user-balance/balance-critical.svg" alt="critical" />
        </div>
        <template v-if="userRemainingBalanceDays > 0">
          <h3 class="custom fs-7 fw-800 text-center mb-0 mt-7">
            {{ formatSum(userAvailableBalance) }} enough for ~{{ userRemainingBalanceDays }}
            days
          </h3>
          <div class="mt-3 text-center">Don’t wait — top up your balance now to avoid service interruptions.</div>
        </template>
        <template v-else>
          <h3 class="custom fs-7 fw-800 text-center mb-0 mt-7">
            {{ formatSum(userAvailableBalance) }} Left – Immediate Action Required
          </h3>
          <div class="mt-3 text-center">
            Your funds are out. Campaign will pause soon — pay a new invoice now to avoid disruption.
          </div>
        </template>
        <button @click="openInvoiceModal" class="btn btn-primary custom mt-8">Generate Proforma Invoice</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.alert-modal {
  width: 365px;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 999;

  border-radius: 15px;
  border: 1px solid #d9d9d9;
  background: #fff;
  box-shadow:
    0px 23.333px 117.715px 0px rgba(0, 0, 0, 0.05),
    0px 13.867px 64.022px 0px rgba(0, 0, 0, 0.04),
    0px 7.2px 32.662px 0px rgba(0, 0, 0, 0.03),
    0px 2.933px 16.378px 0px rgba(0, 0, 0, 0.02),
    0px 0.667px 7.91px 0px rgba(0, 0, 0, 0.01);
}

.alert-inner {
  position: relative;
  padding: 56px 24px;
}

.btn-close {
  position: absolute;
  right: 16px;
  top: 16px;
}
</style>
